import { render, staticRenderFns } from "./ApplicantOnboardingGeneralMainUser.vue?vue&type=template&id=ce49b746&"
import script from "./ApplicantOnboardingGeneralMainUser.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingGeneralMainUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports